import React from 'react'
import Link from 'next/link'
import { assets } from '@/helpers/common'
import Meta from '@/components/common/Meta'
import { BOOK_NOW } from '@/router/allUrls'
import { AboutUsSrOnly } from '@/v1/sr-only'
import { META_CONTENTS } from '@/v1/constants/seo'
import Promotion from '@/components/sections/Promotion'
import AboutUsBanner from '@/components/banners/AboutUsBanner'
import FeatureBox from '@/components/subComponents/FeatureBox'

function AboutUs() {
  return (
    <>
      <Meta
        title={META_CONTENTS.about.title}
        keywords={META_CONTENTS.about.keywords}
        description={META_CONTENTS.about.description}
      />

      <AboutUsSrOnly />

      <AboutUsBanner />

      <section className='mobile-banner-content-section md-mn:hidden section-spacing--small'>
        <div className='container'>
          <div className='row sm-mx:flex-col-reverse'>
            <div className='w-full text-center'>
              <div className='banner-content text-center'>
                <h2 className='text-4xl2 font-bold text-secondary mb-4 sm-mx:text-2xl26 sm-mx:mb-1'>About Us</h2>
                <p className='text-2xl font-normal text-gray-400 mb-4 sm-mx:text-base'>
                  "Ship And Storage" combines shipping and storage, making it simple to send boxes to{' '}
                  <br className='md-mx:hidden' /> self-storage and receive them back, even if you're in another city.
                  "Ship And Storage" provides <br className='md-mx:hidden' /> services such as ship-to-school,
                  ship-to-office, and ship-to-home that are ideal for job <br className='md-mx:hidden' /> relocation,
                  study abroad, and summer vacations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className='container'>
          <div className='row sm-mx:flex-col-reverse mt-10 mb-10'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block'>Our Mission</h2>
                <p>
                  We ensure the simplest way of storage system than what is existing now. We are willing to provide{' '}
                  <br className='md-mx:hidden' />{' '}
                  <Link href='/' className='font-medium text-secondary'>
                    Smart Storage
                  </Link>{' '}
                  that grows or shrinks with your needs, as well as to adopt an easy way of{' '}
                  <br className='md-mx:hidden' /> shipping your belongings wherever you travel.
                </p>
              </div>
            </div>
          </div>

          <div className='row sm-mx:flex-col-reverse mt-10 mb-10 container'>
            <div className='w-full text-center'>
              <div className='banner-content text-center'>
                <h2 className='text-2xl md-mx:text-2xl font-semibold text-secondary'>We Have</h2>
                <h5 className='text-lg font-medium'>Two types of storage, like.</h5>
              </div>

              <div className='pt-12 sm-mx:pt-5 grid gap-y-10 lg-mx:gap-y-5 grid-cols-2 md-mx:grid-cols-2 md-mx:gap-x-5 sm-mx:grid-cols-1 sm-mx:gap-0'>
                <div className='px-5 lg-mx:px-0 sm-mx:w-full text-center'>
                  <FeatureBox title='Business Storage' icon='images/about-us/warehouse.png'>
                    <p>
                      Modern Businesses necessitates cutting-edge
                      <br className='md-mx:hidden' /> storage solutions. We have smart storage solution{' '}
                      <br className='md-mx:hidden' /> for all your business needs.{' '}
                      <Link href='/business-storage' className='text-secondary'>
                        See More
                      </Link>
                    </p>
                  </FeatureBox>
                </div>

                <div className='px-5 lg-mx:px-0 sm-mx:w-full text-center'>
                  <FeatureBox title='Residential Storage' icon='images/about-us/residential-storage.png'>
                    <p>
                      For every movement of your life, you may need extra
                      <br className='md-mx:hidden' /> space! Self-storage will make your life easier, and we
                      <br className='md-mx:hidden' /> take care for you in every steps.{' '}
                      <Link href='/residential-storage' className='text-secondary'>
                        See More
                      </Link>
                    </p>
                  </FeatureBox>
                </div>
              </div>
            </div>
          </div>

          <div className='row sm-mx:flex-col-reverse mt-10 mb-10'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block'>We Can Help</h2>
                <p>
                  Wouldn't it be nice if you could just store your boxes at a self-storage facility and get them{' '}
                  <br className='md-mx:hidden' />
                  without having to go to a bad part of town and look for items?
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='moving-why-different-section bg-white-ice pt-16 pb-8'>
        <div className='container'>
          <div className='row justify-between items-end'>
            <div className='w-8/12 md-mx:w-7/12 xs:w-full text-right flex justify-end md-mx:justify-center items-end lg:items-center xs:mb-3'>
              <img className='inline-block' src={assets('images/about-us/shipping-help.png')} alt='We Can Help?' />
            </div>

            <div className='w-4/12 md-mx:w-5/12 xs:w-full md-mx:text-center xs:text-left'>
              <ul className='list-style-one font-medium md-mx:inline-block md-mx:text-left text-2xl'>
                <li className='mb-1'>Students</li>
                <li className='mb-1'>Business Travelers</li>
                <li className='mb-1'>Doctors/Nurse</li>
                <li className='mb-1'>Small Businesses</li>
                <li className='mb-1'>E-Commerce Business</li>
                <li className='mb-1'>Players</li>
                <li className='mb-1'>Movers</li>
                <li>Small/Mid/Big Families</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Promotion className='moving-promotion'>
        <>
          <img className='sm-mx:hidden' src={assets('images/promotion-bg-two.png')} alt={''} />
          <div className='promotion-inner flex justify-center items-center'>
            <div className='promotion-content inline-block text-center pt-48 md-mx:pt-36 sm-mx:pt-0'>
              <p className='text-3xl mb-2 md-mx:text-lg md-mx:mb-0'>Photos, clothing, toys, gifts, and more can be</p>
              <h2>Moved + stored + shipped safely! </h2>
              <p className='text-3xl mb-10 md-mx:text-lg md-mx:mb-5'>We are the cheapest option for you.</p>
              <Link href={BOOK_NOW} className='btn btn-primary'>
                Get Started
              </Link>
              <p className='text-sas-gray-700 text-sm13 font-medium'>
                A valet storage experience that you will love it
              </p>
            </div>
          </div>
        </>
      </Promotion>
    </>
  )
}

export default AboutUs
